export default function () {
  if (this.$route.name === 'EditRedirect') {
    this.load()
  }
}
